import React from 'react';
import { FinancialDetails } from 'common';
import { DefinitionList, DefinitionListItem } from '@cp-shared-10/frontend-ui';
import { useTranslationWithFormatting } from 'localization/useTranslationWithFormatting';
import { getGeneralSectionListItems } from '../utils';
import { Button, Heading } from '@vwfs-bronson/bronson-react';
import { useHistory } from 'react-router-dom';
import { changeContractDurationPath } from 'components/navigation/paths';

type GeneralSectionProps = {
    details: FinancialDetails;
    encryptedContractNumber: string;
    changeContractDurationAvailable?: boolean;
};

export const GeneralSection: React.FC<GeneralSectionProps> = ({
    details,
    encryptedContractNumber,
    changeContractDurationAvailable,
}) => {
    const { t, f } = useTranslationWithFormatting('financial-details');
    const history = useHistory();
    if (!details) return null;
    const itemList: DefinitionListItem[] = getGeneralSectionListItems(t, f, details);

    return (
        <>
            <Heading className={'c-data-overview__header u-pt'} level={5}>
                {t('general-section.headline')}
                {changeContractDurationAvailable && (
                    <Button
                        element="a"
                        link
                        small
                        className="c-data-overview__button u-mb-none u-mt-none u-mr-small"
                        icon="true"
                        iconReversed
                        onClick={() => history.push(changeContractDurationPath(encryptedContractNumber))}
                        testId={'edit-button'}
                    >
                        {t('translation:editable-section-nav.start')}
                    </Button>
                )}
            </Heading>
            <DefinitionList split={true} list={itemList} />
        </>
    );
};
